module.exports = __webpack_public_path__ + "static/media/moneytree-logo.6ff00548.svg";